// 发送验证码的通用ui逻辑
import { Vue, Component } from "vue-property-decorator";
import {sendVerifyCode} from '../service';

@Component
export default class ClockMgr extends Vue {
    // 短信验证码间隔
    public timeout = 60;

    public codetext = this.$t('components.login.sendtextcode');
    public regainTime = 60;
    public liveTime = 60;
    public clock:any = null;
    public canSend = true;
    public codestrRegain = this.$t('components.login.regettextcode');
    public codeClockStr = "";
    /*
     * 发送验证码
     */
    public sendVeriCode(codeKey:any) {
        const self = this;

        if (!this.canSend) {
            this.$Message.error({
                content:  this.$t('components.login.pleasewaittosend') as string,
                duration: 3,
            });
            return;
        }
        const fm = this.$refs.loginForm;
        // @ts-ignore
        this.$refs.loginForm.validateField("phone",(err) => {
            if(!err){
                // @ts-ignore
                sendVerifyCode(self,self.form.phone,codeKey,self.form.code).then(isOk => {
                    self.$Message[isOk ? "success" : "error"]({
                        // @ts-ignore
                        content:isOk ? self.$t('components.login.textalreadysend') : self.$t('components.login.textsendfail'),
                        duration: 3
                    });
                    if(isOk){
                        self.canSend = false;
                        self.dropSand();
                    }
                });
            }
        });
    }
    // 倒计时
    dropSand():any {
        this.codetext = this.liveTime + ' '+this.$t('components.login.textcodeunit');

        if (this.liveTime === 0) {
          this.codetext = this.codestrRegain;
          this.canSend = true;
          this.liveTime = this.regainTime;
          clearTimeout(this.clock);
          return;
        }

        this.clock = setTimeout(() => {
          this.liveTime--;
          this.dropSand();
        }, 1000);
      }
}
